export const environment = {
  production: true,
  test: false,
  dev: false,
  isDebugMode: false,
  // apiBackendUrl: 'http://localhost:8000',
  apiBackendUrl: 'https://system.cocopetkh.com',
  toastrConfig: {
    timeOut: 5000,
    // tapToDismiss: true,
    progressBar: true,
    positionClass: 'toast-top-center'
  },
};
